import { Component } from '@angular/core';

@Component({
  selector: 'sume-submit-preloader',
  template: `<ngx-spinner
      [fullScreen]="false"
      name="sume-submit-preloader"
    ></ngx-spinner>
    <!-- teste -->`,
})
export class SubmitPreloaderComponent {}
